module.exports = __webpack_public_path__ + "static/img/order-default-necklace.2a8f5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/order-default-necklace.png
// module id = 1344
// module chunks = 0